import React, { memo } from "react";

const EmailLink = memo(({ children, subject = null }) => {
  return (
    <a href={`mailto:${children}${subject && `?subject=${subject}`}`} className="custom-link">
      {children}
    </a>
  );
});

export default EmailLink;
